import React from 'react';
import PropTypes from 'prop-types';
import { EditorState, convertFromRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';

import Card from './card';
import CustomDetail from './custom_detail';

const TOOLBAR_SETTINGS = { link: { showOpenOptionOnHover: false }, options: [] };

export default class Custom extends React.Component {
  static propTypes = {
    card: PropTypes.shape({
      content: PropTypes.string,
      id: PropTypes.number,
      subtitle: PropTypes.string,
      title: PropTypes.string,
      visibleToClient: PropTypes.bool
    }),
    fullScreen: PropTypes.bool,
    onRemove: PropTypes.func,
    onSave: PropTypes.func,
    onSetAsActive: PropTypes.func.isRequired,
    onUploadImage: PropTypes.func
  }

  closeDetailView = () => {
    this.props.onSetAsActive(null);
  }

  renderPrevew() {
    if (!this.props.card.content && !this.props.card.visibleToClient) {
      return (
        <div className="text-center p-5">
          <h4>Edit this card to add your own content.</h4>
        </div>
      );
    }

    const content = this.props.card.content && JSON.parse(this.props.card.content);
    const editorState = content ? EditorState.createWithContent(convertFromRaw(content)) : EditorState.createEmpty();

    return (
      <Editor
        editorState={editorState}
        readOnly
        toolbar={TOOLBAR_SETTINGS}
        toolbarClassName="hidden"
      />
    );
  }

  renderDetail() {
    return (
      <CustomDetail
        card={this.props.card}
        onClose={this.closeDetailView}
        onRemove={this.props.onRemove}
        onSave={this.props.onSave}
        onUploadImage={this.props.onUploadImage}
      />
    );
  }

  renderBody() {
    if (!this.isEditing()) return this.renderPrevew();

    return this.renderDetail();
  }

  title() {
    if (this.isEditing()) {
      return this.props.card.id ? 'Edit Custom Tile' : 'New Custom Tile';
    }

    return this.props.card.title;
  }

  subtitle() {
    return this.isEditing() ? '' : this.props.card.subtitle;
  }

  isEditing() {
    return this.props.fullScreen && this.props.onSave;
  }

  render() {
    const { onSetAsActive, ...passThroughProps } = this.props;

    return (
      <Card
        {...passThroughProps}
        subtitle={this.subtitle()}
        title={this.title()}
        onSetAsActive={onSetAsActive}
      >
        {this.renderBody()}
      </Card>
    );
  }
}
